import React from "react";

export default function AuthorPage() {
  return (
    <div className="Page">
      <header className="Page-header">
        <h1>Author</h1>
      </header>
      <section className="Page-body">
        <h2>Paul Rumkin</h2>
        <p>
          Hi, I'm Paul Rumkin. And I built this collaboration demonstration. I'm
          also working on other projects like WebAPI changed web server called
          Plant and other.
        </p>
        <ul>
          <li>
            <a href="https://rumk.in">Homepage</a>
          </li>
          <li>
            <a href="https://github.com/rumkin">Github</a>
          </li>
          <li>
            <a href="https://twitter.com/rumkin">Twitter</a>
          </li>
        </ul>
      </section>
    </div>
  );
}
